import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import SearchBar from "./../../../component/atoms/input/searchBar";
import { route } from "./../../../router/route";
import moment from "moment";
import { errorHandler } from "../../../util/errorHandler";
import RedBtn from "../../../component/atoms/button/redBtn";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import Modal from "../../../component/templates/Modal";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import PopupOverLay from "../../../component/templates/PopupOverlay";
import Popup from "../../../component/molecules/popup";
import styled from "styled-components";
import PretendardText from "../../../component/atoms/text/pretendardText";
import SubSideBar from "../../../component/organisms/subSideBar";
import SubSideBarItem from "../../../component/molecules/subSideBarItem";
import MainInput from "./../../../component/atoms/input/mainInput";
import { useNavigate } from "react-router-dom";
import scrollToTop from "../../../util/scrollToTop";
import SelectBox from "../../../component/organisms/selectBox";
import DividedBtn from "../../../component/atoms/button/dividedBtn";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import Radio from "../../../component/atoms/input/radio";
import TextArea from "./../../../component/atoms/input/textarea";
import DateInput from "./../../../component/atoms/input/dateInput";
import { hourList, minuteList } from "../../../constants/timeArr";
import { useRecoilState } from "recoil";
import {
  productIsUploadState,
  productManagementState,
} from "../../../store/productState";
import ProductApi from "../../../api/product.api";

// TODO:
// - 추후 미리보기 페이지 구현 필요 (프리뷰 페이지 별도로 만들어야 할듯)
// - 추후에 연관 상품, 오픈 알림 전송 기능 구현 필요

const ShoppingProductCreateEtc = () => {
  const navigate = useNavigate();

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    // 편집 권한 체크
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (!writeMenu?.includes(route.shopping_product)) {
      navigate(-1);
      toast(
        <>
          편집 권한이 없습니다.
          <br />
          최고관리자에게 문의하세요.
        </>
      );
      return;
    }

    getStorageList();

    // url 직접 입력으로 들어온 경우 기본 내용 설정 페이지로 이동
    if (!productManagementValue.id) {
      navigate(route.shopping_product_create_basic);
      setProductIsUpload(true);
    } else {
      setProductIsUpload(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 페이지 타이틀 관련 ---------- //
  const pageTitleList = [
    "01. 기본 내용 설정",
    "02. 상세 내용 설정",
    "03. 목차/커리큘럼 설정",
    "04. 썸네일 및 배너 설정",
    "05. 기타 설정",
  ];

  // ---------- 상품 업로드 상태 관련 ---------- //
  const [, setProductIsUpload] = useRecoilState(productIsUploadState);

  // ---------- 상품 추가 입력값 관련 ---------- //
  const [productManagementValue, setProductManagementValue] = useRecoilState(
    productManagementState
  );

  // ---------- 전체 영역 모달창 관련 ---------- //
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");

  // ---------- 전체 영역 팝업 상태 관련 ---------- //
  const [popupOpen, setPopupOpen] = useState({
    temporary: false, // 임시저장
    relationProduct: false,
  });

  // ---------- 연관 상품 추가하기 관련 ---------- //
  const [relatedMerchInputValue, setRelatedMerchInputValue] = useState("");
  const [searchMerchList, setSearchMerchList] = useState([]);
  const [searchResultIsEmpty, setSearchResultIsEmpty] = useState(false);

  // 연관 상품 검색 함수
  const searchMerchFunc = async () => {
    const data = {
      page: 1,
      size: 0,
      saveStatus: "Y",
      merchMainCategoryId: 1,
      merchType: "SHOP",
      merchContentType: "BOOK",
      keyword: relatedMerchInputValue,
    };

    try {
      const response = (await ProductApi.getListProduct(data)).data.data
        .content;

      if (response.length === 0) {
        setSearchResultIsEmpty(true);
      } else {
        setSearchResultIsEmpty(false);
      }

      setSearchMerchList(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 임시저장 관련 ---------- //
  const [storageList, setStorageList] = useState([]);
  const [storageListCount, setStorageListCount] = useState(0);
  const [storageData, setStorageData] = useState({});

  const getStorageList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        saveStatus: "N",
      };
      const response = await ProductApi.getListProduct(data);
      setStorageList(response.data.data.content);
      setStorageListCount(response.data.data.totalCount);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 임시저장 데이터 삭제 관련
  const [deleteStorageItemModalOpen, setDeleteStorageItemModalOpen] =
    useState(false);
  const [deleteStorageItemId, setDeleteStorageItemId] = useState(0);

  const handleDeleteStorageItem = async () => {
    try {
      await ProductApi.deleteProduct(deleteStorageItemId);
      toast(toastMsg.delete);
      setDeleteStorageItemModalOpen(false);
      getStorageList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // 데이터 불러오기
  const handleLoadStorageItem = async (id) => {
    try {
      const response = (await ProductApi.getByIdProduct(id)).data.data.content;
      setStorageData(response);

      setProductManagementValue({
        ...response,
        merchMainCategoryId: response?.merchMainCategory?.id || 0,
        merchSubCategoryId: response?.merchSubCategory?.id || 0,
        title: response.title || "",
        writer: response.writer || "",
        price: response.price || 0,
        isPreviewEnabled: response.isPreviewEnabled || false,
        isFreeTrial: response.isFreeTrial || false,
        isComingSoon: response.isComingSoon || false,
        isMembershipOnly: response.isMembershipOnly || false,
        intro: response.intro || "",
        content: response.content || "",
        thumbnailOriginFileName: response.thumbnailOriginFileName || "",
        thumbnailServerFileName: response.thumbnailServerFileName || "",
        bannerOriginFileName: response.bannerOriginFileName || "",
        bannerServerFileName: response.bannerServerFileName || "",
        relatedMerchUse: response.relatedMerchUse || false,
        relatedMerchIdList: response.relatedMerchIdList || [],
        relatedMerchList: response.relatedMerchList || [],
        openAlarmUse: response.openAlarmUse || false,
        merchType: response.merchType || "SHOP",
        merchContentType: response.merchContentType || "BOOK",
      });
      setProductIsUpload(false);
      setPopupOpen((prevPopup) => ({
        ...prevPopup,
        temporary: false,
      }));

      navigate(route.shopping_product_create_basic);
      toast("임시저장 데이터를 불러왔습니다.");
      scrollToTop();
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 오픈 알림 전송 관련 ---------- //
  const [etcSettingStatus, setEtcSettingStatus] = useState({
    alarm: false,
    sms: false,
  });

  // 발송 대상 관련
  const [sendTargetBoxOpen, setSendTargetBoxOpen] = useState(false);
  const [selectedSendTarget, setSelectedSendTarget] = useState("");

  const sendTargetList = [
    {
      title: "오픈 알림 받기를 신청한 회원",
      value: "오픈 알림 받기를 신청한 회원",
    },
    {
      title: "혜택 알림 수신에 동의한 모든 회원",
      value: "혜택 알림 수신에 동의한 모든 회원",
    },
  ];

  const [alarmContent, setAlarmContent] = useState("");

  const [selectedSendTimeType, setSelectedSendTimeType] = useState("지금");

  const [sendTimeValue, setSendTimeValue] = useState("");

  const [hourBoxOpen, setHourBoxOpen] = useState(false);
  const [selectedHour, setSelectedHour] = useState("");

  const [minuteBoxOpen, setMinuteBoxOpen] = useState(false);
  const [selectedMinute, setSelectedMinute] = useState("");

  const [smsTitle, setSmsTitle] = useState("");
  const [smsContent, setSmsContent] = useState("");

  // ---------- 업로드 관련 ---------- //
  const [createModalOpen, setCreateModalOpen] = useState(false);

  // 상품 추가하기 전 상품 업데이트
  const updateProductFunc = async () => {
    try {
      await ProductApi.updateProduct(
        productManagementValue.id,
        productManagementValue
      );
    } catch (error) {
      errorHandler(error);
    }
  };

  // 상품 추가하기 함수
  const createProductFunc = async () => {
    try {
      await ProductApi.uploadProduct(productManagementValue.id);
      setCreateModalOpen(false);
      toast("상품이 추가되었습니다.");
      navigate(route.shopping_product);
      scrollToTop();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 카테고리 영역 */}
        <SubSideBar title="상품 추가">
          {pageTitleList.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <SubSideBarItem
                  style={{
                    cursor: "default",
                  }}
                  selected={item === pageTitleList[4]}
                >
                  {item}
                </SubSideBarItem>
              </React.Fragment>
            );
          })}
        </SubSideBar>

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>{pageTitleList[4]}</TableTitle>
          {/* 연관 상품 */}
          <div
            style={{
              width: "100%",
              padding: "24px 0px",
              display: "flex",
              flexDirection: "column",
              borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <PretendardText
                style={{
                  width: 122,
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "22.75px",
                  color: "#aaa",
                }}
              >
                연관 상품
              </PretendardText>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 30,
                }}
              >
                <Radio
                  id={"relatedMerchUseFalse"}
                  valueText={"사용 안함"}
                  checked={!productManagementValue.relatedMerchUse}
                  onChange={() => {
                    setProductManagementValue({
                      ...productManagementValue,
                      relatedMerchUse: false,
                    });
                  }}
                />
                <Radio
                  id={"relatedMerchUseTrue"}
                  valueText={"사용함"}
                  checked={productManagementValue.relatedMerchUse}
                  onChange={() => {
                    // setModalOpen(true);
                    // setModalMsg(<>현재 해당 기능은 사용할 수 없습니다.</>);
                    if (productManagementValue.merchMainCategoryId !== 1) {
                      setModalOpen(true);
                      setModalMsg(
                        <>
                          전자책만 연관 상품을
                          <br />
                          설정할 수 있습니다.
                        </>
                      );
                    } else {
                      setProductManagementValue({
                        ...productManagementValue,
                        relatedMerchUse: true,
                      });
                    }
                  }}
                />
              </div>
            </div>

            {productManagementValue.relatedMerchUse && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: 122,
                }}
              >
                <GrayBtn
                  style={{
                    marginTop: 16,
                  }}
                  onClick={() => {
                    setPopupOpen((prevPopup) => ({
                      ...prevPopup,
                      relationProduct: true,
                    }));
                  }}
                >
                  연관 상품 추가하기
                </GrayBtn>
                <div
                  style={{
                    marginTop: 20,
                    display: "flex",
                    flexDirection: "column",
                    width: 572,
                  }}
                >
                  {productManagementValue.relatedMerchList.map(
                    (item, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 10,
                            padding: "15px 0px",
                            borderBottom:
                              "0.5px solid rgba(255, 255, 255, 0.12)",
                          }}
                        >
                          <PretendardText
                            className="truncate"
                            style={{
                              width: 500,
                              fontSize: "14px",
                              fontWeight: "400",
                              lineHeight: "22px",
                              color: "#aaa",
                            }}
                          >
                            {item.title}
                          </PretendardText>
                          <RedBtn
                            onClick={() => {
                              setProductManagementValue({
                                ...productManagementValue,
                                relatedMerchIdList:
                                  productManagementValue.relatedMerchIdList.filter(
                                    (value, idx) => value !== item.id
                                  ),
                                relatedMerchList:
                                  productManagementValue.relatedMerchList.filter(
                                    (value, idx) => value.id !== item.id
                                  ),
                              });
                            }}
                          >
                            삭제
                          </RedBtn>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            )}
          </div>

          {/* 오픈 알림 전송 */}
          <div
            style={{
              width: "100%",
              padding: "24px 0px",
              display: "flex",
              flexDirection: "column",
              borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
              }}
            >
              <PretendardText
                style={{
                  width: 122,
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "22.75px",
                  color: "#aaa",
                }}
              >
                오픈 알림 전송
              </PretendardText>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 30,
                  }}
                >
                  <Radio
                    id={"openAlarmUseFalse"}
                    valueText={"사용 안함"}
                    checked={!productManagementValue.openAlarmUse}
                    onChange={() => {
                      setProductManagementValue({
                        ...productManagementValue,
                        openAlarmUse: false,
                      });
                      setEtcSettingStatus({
                        alarm: false,
                        sms: false,
                      });
                    }}
                  />
                  <Radio
                    id={"openAlarmUseTrue"}
                    valueText={"사용함"}
                    checked={productManagementValue.openAlarmUse}
                    onChange={() => {
                      setModalOpen(true);
                      setModalMsg(<>현재 해당 기능은 사용할 수 없습니다.</>);
                      // setProductManagementValue({
                      //   ...productManagementValue,
                      //   openAlarmUse: true,
                      // });
                      // setEtcSettingStatus({
                      //   alarm: true,
                      //   sms: false,
                      // });
                    }}
                  />
                </div>
                <PretendardText
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    lineHeight: "18.75px",
                    color: "rgba(181, 181, 181, 0.5)",
                  }}
                >
                  오픈 예정 상품이 오픈 시, 알림 받기를 신청 했던 이용자 및 혜택
                  알림 수신에 동의한 이용자들에게 알림을 전송합니다.
                </PretendardText>
              </div>
            </div>

            {productManagementValue.openAlarmUse && (
              <div
                style={{
                  width: "100%",
                  height: 63,
                  display: "flex",
                  alignItems: "flex-end",
                  gap: 10,
                  borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                }}
              >
                <PretendardText
                  style={{
                    width: 125,
                    height: 63,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "25px",
                    letterSpacing: "-0.3%",
                    color: etcSettingStatus.alarm
                      ? "#27BEFF"
                      : "rgba(181, 181, 181, 0.5)",
                    borderBottom: etcSettingStatus.alarm && "2px solid #27BEFF",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setEtcSettingStatus({
                      alarm: true,
                      sms: false,
                    });
                  }}
                >
                  알림
                </PretendardText>
                <PretendardText
                  style={{
                    width: 125,
                    height: 63,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "25px",
                    letterSpacing: "-0.3%",
                    color: etcSettingStatus.sms
                      ? "#27BEFF"
                      : "rgba(181, 181, 181, 0.5)",
                    borderBottom: etcSettingStatus.sms && "2px solid #27BEFF",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setEtcSettingStatus({
                      alarm: false,
                      sms: true,
                    });
                  }}
                >
                  SMS
                </PretendardText>
              </div>
            )}

            {/* 오픈 알림 전송 - 알림 */}
            {etcSettingStatus.alarm && (
              <>
                {/* 오픈 알림 전송 - 알림 - 발송대상 */}
                <BasicContentSettingInputWrapper
                  style={{
                    padding: "21px 0px",
                    alignItems: "flex-start",
                  }}
                >
                  <BasicContentSettingInputTitle>
                    발송대상
                  </BasicContentSettingInputTitle>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 12,
                    }}
                  >
                    <SelectBox
                      placeholder="발송 대상을 선택해주세요"
                      selectedValue={selectedSendTarget.title || ""}
                      isOpen={sendTargetBoxOpen}
                      wrapperHandler={() => {
                        setSendTargetBoxOpen(!sendTargetBoxOpen);
                      }}
                      itemList={sendTargetList}
                      selectedValueSetterFunc={setSelectedSendTarget}
                    />
                    <PretendardText
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        lineHeight: "18.75px",
                        color: "rgba(181, 181, 181, 0.5)",
                      }}
                    >
                      개별 회원에게 보내고 싶으시면 [회원관리]에서 사용자를
                      선택하여 발송하세요.
                    </PretendardText>
                  </div>
                </BasicContentSettingInputWrapper>
                {/* 오픈 알림 전송 - 알림 - 알림 제목 */}
                <BasicContentSettingInputWrapper
                  style={{
                    padding: "21px 0px",
                    alignItems: "flex-start",
                  }}
                >
                  <BasicContentSettingInputTitle>
                    알림 제목
                  </BasicContentSettingInputTitle>
                  <MainInput
                    type={"text"}
                    placeholder={"알림 제목을 입력해 주세요."}
                    style={{ width: "572px" }}
                    value={""}
                    onChange={() => {}}
                  />
                </BasicContentSettingInputWrapper>
                {/* 오픈 알림 전송 - 알림 - 알림 내용 */}
                <BasicContentSettingInputWrapper
                  style={{
                    padding: "21px 0px",
                    alignItems: "flex-start",
                  }}
                >
                  <BasicContentSettingInputTitle>
                    알림 내용
                  </BasicContentSettingInputTitle>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                    }}
                  >
                    <TextArea
                      type={"text"}
                      placeholder={"알림 내용을 입력해주세요"}
                      value={alarmContent}
                      onChange={(e) => {
                        setAlarmContent(e.target.value);
                      }}
                      maxLength={50}
                      style={{
                        width: "572px",
                        minHeight: "107px",
                      }}
                    />
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          lineHeight: "18.75px",
                          color: "rgba(181, 181, 181, 0.5)",
                        }}
                      >
                        {alarmContent.length}/50
                      </PretendardText>
                    </div>
                  </div>
                </BasicContentSettingInputWrapper>
                {/* 오픈 알림 전송 - 알림 - URL 입력 */}
                <BasicContentSettingInputWrapper
                  style={{
                    padding: "21px 0px",
                    alignItems: "flex-start",
                  }}
                >
                  <BasicContentSettingInputTitle>
                    URL 입력
                    <br />
                    (선택사항)
                  </BasicContentSettingInputTitle>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 12,
                    }}
                  >
                    <MainInput
                      type={"text"}
                      placeholder={"URL을 입력해 주세요."}
                      style={{ width: "572px" }}
                      value={""}
                      onChange={() => {}}
                    />
                    <PretendardText
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        lineHeight: "18.75px",
                        color: "rgba(181, 181, 181, 0.5)",
                      }}
                    >
                      알림창을 클릭 시 이동할 페이지
                    </PretendardText>
                  </div>
                </BasicContentSettingInputWrapper>
                {/* 오픈 알림 전송 - 알림 - 발송 시간 */}
                <BasicContentSettingInputWrapper
                  style={{
                    padding: "21px 0px",
                    alignItems: "flex-start",
                    borderBottom: "none",
                  }}
                >
                  <BasicContentSettingInputTitle>
                    발송 시간
                  </BasicContentSettingInputTitle>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 30,
                      }}
                    >
                      <Radio
                        id={""}
                        valueText={"지금"}
                        checked={selectedSendTimeType === "지금"}
                        onChange={() => {
                          setSelectedSendTimeType("지금");
                        }}
                      />
                      <Radio
                        id={""}
                        valueText={"예약"}
                        checked={selectedSendTimeType === "예약"}
                        onChange={() => {
                          setSelectedSendTimeType("예약");
                        }}
                      />
                    </div>
                    {selectedSendTimeType === "예약" && (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          marginTop: 24,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontWeight: 500,
                            fontSize: 13,
                            lineHeight: "18.75px",
                            color: "#aaa",
                            marginBottom: 10,
                          }}
                        >
                          예약한 시간에 업로드 됩니다
                        </PretendardText>
                        <DateInput
                          value={sendTimeValue}
                          onChange={(e) => {
                            setSendTimeValue(e.target.value);
                          }}
                        />
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 20,
                            marginTop: 16,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <SelectBox
                              isSmall={true}
                              placeholder="00"
                              selectedValue={selectedHour.title || ""}
                              isOpen={hourBoxOpen}
                              wrapperHandler={() => {
                                setHourBoxOpen(!hourBoxOpen);
                              }}
                              itemList={hourList}
                              selectedValueSetterFunc={setSelectedHour}
                            />
                            <PretendardText
                              style={{
                                fontWeight: 500,
                                fontSize: 15,
                                lineHeight: "21.5px",
                                color: "#aaa",
                              }}
                            >
                              시
                            </PretendardText>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <SelectBox
                              isSmall={true}
                              placeholder="00"
                              selectedValue={selectedMinute.title || ""}
                              isOpen={minuteBoxOpen}
                              wrapperHandler={() => {
                                setMinuteBoxOpen(!minuteBoxOpen);
                              }}
                              itemList={minuteList}
                              selectedValueSetterFunc={setSelectedMinute}
                            />
                            <PretendardText
                              style={{
                                fontWeight: 500,
                                fontSize: 15,
                                lineHeight: "21.5px",
                                color: "#aaa",
                              }}
                            >
                              분
                            </PretendardText>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </BasicContentSettingInputWrapper>
                <div
                  style={{
                    width: "100%",
                    height: 79,
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                    gap: 12,
                  }}
                >
                  <BasicBtn onClick={() => {}}>발송하기</BasicBtn>
                </div>
              </>
            )}

            {/* 오픈 알림 전송 - SMS */}
            {etcSettingStatus.sms && (
              <>
                {/* 오픈 알림 전송 - SMS - 발신번호(인증한 경우) */}
                <BasicContentSettingInputWrapper
                  style={{
                    padding: "21px 0px",
                    alignItems: "flex-start",
                  }}
                >
                  <BasicContentSettingInputTitle>
                    발신번호
                  </BasicContentSettingInputTitle>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <PretendardText
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        lineHeight: "22.75px",
                        color: "#aaa",
                      }}
                    >
                      01012345678
                    </PretendardText>
                    <PretendardText
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        lineHeight: "22.75px",
                        color: "#009bde",
                      }}
                    >
                      인증완료
                    </PretendardText>
                    <GrayBtn>발신번호 변경</GrayBtn>
                  </div>
                </BasicContentSettingInputWrapper>
                {/* 오픈 알림 전송 - SMS - 발신번호(미인증인 경우) */}
                <BasicContentSettingInputWrapper
                  style={{
                    padding: "21px 0px",
                    alignItems: "flex-start",
                  }}
                >
                  <BasicContentSettingInputTitle>
                    발신번호
                  </BasicContentSettingInputTitle>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 14,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                      }}
                    >
                      <PretendardText
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          lineHeight: "22.75px",
                          color: "#cf6679",
                        }}
                      >
                        미인증
                      </PretendardText>
                      <GrayBtn>발신번호 인증</GrayBtn>
                    </div>
                    <PretendardText
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        lineHeight: "18.75px",
                        color: "#cf6679",
                      }}
                    >
                      전기통신사업법에 따라 유효한 번호로만 발신 가능하며, 인증
                      후 SMS 사용이 가능합니다
                    </PretendardText>
                  </div>
                </BasicContentSettingInputWrapper>
                {/* 오픈 알림 전송 - SMS - 발송대상 */}
                <BasicContentSettingInputWrapper
                  style={{
                    padding: "21px 0px",
                    alignItems: "flex-start",
                  }}
                >
                  <BasicContentSettingInputTitle>
                    발송대상
                  </BasicContentSettingInputTitle>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 12,
                    }}
                  >
                    <SelectBox
                      placeholder="발송 대상을 선택해주세요"
                      selectedValue={selectedSendTarget || ""}
                      isOpen={sendTargetBoxOpen}
                      wrapperHandler={() => {
                        setSendTargetBoxOpen(!sendTargetBoxOpen);
                      }}
                      itemList={sendTargetList}
                      selectedValueSetterFunc={setSelectedSendTarget}
                    />
                    <PretendardText
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        lineHeight: "18.75px",
                        color: "rgba(181, 181, 181, 0.5)",
                      }}
                    >
                      개별 회원에게 보내고 싶으시면 [회원관리]에서 사용자를
                      선택하여 발송하세요.
                    </PretendardText>
                  </div>
                </BasicContentSettingInputWrapper>
                {/* 오픈 알림 전송 - SMS - 제목 */}
                <BasicContentSettingInputWrapper
                  style={{
                    padding: "21px 0px",
                    alignItems: "flex-start",
                  }}
                >
                  <BasicContentSettingInputTitle>
                    제목
                  </BasicContentSettingInputTitle>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                    }}
                  >
                    <TextArea
                      type={"text"}
                      placeholder={"제목을 입력해주세요"}
                      value={smsTitle}
                      onChange={(e) => {
                        setSmsTitle(e.target.value);
                      }}
                      maxLength={40}
                      style={{
                        width: "572px",
                        height: "50px",
                      }}
                    />
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          lineHeight: "18.75px",
                          color: "rgba(181, 181, 181, 0.5)",
                        }}
                      >
                        제목은 LMS로 발송 시에만 최대 40바이트까지 전송됩니다.
                        (미입력 시 사이트명으로 표기)
                      </PretendardText>
                      <PretendardText
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          lineHeight: "18.75px",
                          color: "rgba(181, 181, 181, 0.5)",
                        }}
                      >
                        {smsTitle.length}/40
                      </PretendardText>
                    </div>
                  </div>
                </BasicContentSettingInputWrapper>
                {/* 오픈 알림 전송 - SMS - 보내실 내용 */}
                <BasicContentSettingInputWrapper
                  style={{
                    padding: "21px 0px",
                    alignItems: "flex-start",
                  }}
                >
                  <BasicContentSettingInputTitle>
                    보내실 내용
                  </BasicContentSettingInputTitle>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                    }}
                  >
                    <TextArea
                      type={"text"}
                      placeholder={"내용을 입력해주세요"}
                      value={smsContent}
                      onChange={(e) => {
                        setSmsContent(e.target.value);
                      }}
                      maxLength={90}
                      style={{
                        width: "572px",
                        minHeight: "107px",
                      }}
                    />
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          lineHeight: "18.75px",
                          color: "rgba(181, 181, 181, 0.5)",
                        }}
                      >
                        {smsContent.length}/90
                      </PretendardText>
                    </div>
                  </div>
                </BasicContentSettingInputWrapper>
                {/* 오픈 알림 전송 - SMS - 발송 시간 */}
                <BasicContentSettingInputWrapper
                  style={{
                    padding: "21px 0px",
                    alignItems: "flex-start",
                    borderBottom: "none",
                  }}
                >
                  <BasicContentSettingInputTitle>
                    발송 시간
                  </BasicContentSettingInputTitle>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 30,
                      }}
                    >
                      <Radio
                        id={""}
                        valueText={"지금"}
                        checked={selectedSendTimeType === "지금"}
                        onChange={() => {
                          setSelectedSendTimeType("지금");
                        }}
                      />
                      <Radio
                        id={""}
                        valueText={"예약"}
                        checked={selectedSendTimeType === "예약"}
                        onChange={() => {
                          setSelectedSendTimeType("예약");
                        }}
                      />
                    </div>
                    {selectedSendTimeType === "예약" && (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          marginTop: 24,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontWeight: 500,
                            fontSize: 13,
                            lineHeight: "18.75px",
                            color: "#aaa",
                            marginBottom: 10,
                          }}
                        >
                          예약한 시간에 발송됩니다
                        </PretendardText>
                        <DateInput
                          value={sendTimeValue}
                          onChange={(e) => {
                            setSendTimeValue(e.target.value);
                          }}
                        />
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 20,
                            marginTop: 16,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <SelectBox
                              isSmall={true}
                              placeholder="00"
                              selectedValue={selectedHour || ""}
                              isOpen={hourBoxOpen}
                              wrapperHandler={() => {
                                setHourBoxOpen(!hourBoxOpen);
                              }}
                              itemList={hourList}
                              selectedValueSetterFunc={setSelectedHour}
                            />
                            <PretendardText
                              style={{
                                fontWeight: 500,
                                fontSize: 15,
                                lineHeight: "21.5px",
                                color: "#aaa",
                              }}
                            >
                              시
                            </PretendardText>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <SelectBox
                              isSmall={true}
                              placeholder="00"
                              selectedValue={selectedMinute || ""}
                              isOpen={minuteBoxOpen}
                              wrapperHandler={() => {
                                setMinuteBoxOpen(!minuteBoxOpen);
                              }}
                              itemList={minuteList}
                              selectedValueSetterFunc={setSelectedMinute}
                            />
                            <PretendardText
                              style={{
                                fontWeight: 500,
                                fontSize: 15,
                                lineHeight: "21.5px",
                                color: "#aaa",
                              }}
                            >
                              분
                            </PretendardText>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </BasicContentSettingInputWrapper>
                <div
                  style={{
                    width: "100%",
                    height: 79,
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                    gap: 12,
                  }}
                >
                  <BasicBtn onClick={() => {}}>발송하기</BasicBtn>
                </div>
              </>
            )}
          </div>

          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            <BasicBtn
              isTransparent={true}
              onClick={() => {
                navigate(route.shopping_product_create_image);
                scrollToTop();
              }}
            >
              이전으로
            </BasicBtn>
            {/* <BasicBtn isBlue={true} onClick={() => {}}>
              상품 등록
            </BasicBtn> */}
            <DividedBtn
              onClick={() => {
                setPopupOpen((prevPopup) => ({
                  ...prevPopup,
                  temporary: true,
                }));
              }}
              text1="임시저장"
              text2={storageListCount}
              textHandler={() => {
                setPopupOpen((prevPopup) => ({
                  ...prevPopup,
                  temporary: true,
                }));
              }}
            />
            <BasicBtn
              onClick={() => {
                updateProductFunc();
                setCreateModalOpen(true);
              }}
            >
              업로드하기
            </BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>

      {/* 연관 상품 추가 팝업 */}
      {popupOpen.relationProduct && (
        <PopupOverLay
          isOpen={true}
          onClick={() => {
            setPopupOpen((prevPopup) => ({
              ...prevPopup,
              relationProduct: false,
            }));
          }}
        >
          <Popup
            headerTitle="연관 상품 추가하기"
            noFooter={true}
            onClick={() => {
              setPopupOpen((prevPopup) => ({
                ...prevPopup,
                relationProduct: false,
              }));
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                padding: "0px 30px",
                margin: "16px 0px 20px 0px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <PretendardText
                  style={{
                    fontSize: "15px",
                    fontWeight: "400",
                    lineHeight: "22px",
                    color: "#aaa",
                    marginBottom: 16,
                  }}
                >
                  추가할 연관상품을 검색하고 선택 버튼을 누르면 반영됩니다.
                </PretendardText>
                <SearchBar
                  style={{
                    backgroundColor: "#313233",
                  }}
                  value={relatedMerchInputValue}
                  onChange={(e) => {
                    setRelatedMerchInputValue(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (relatedMerchInputValue === "") {
                      setSearchMerchList([]);
                      setSearchResultIsEmpty(false);
                      return;
                    } else if (e.key === "Enter") {
                      searchMerchFunc();
                    }
                  }}
                  onClick={() => {
                    if (relatedMerchInputValue === "") {
                      setSearchMerchList([]);
                      setSearchResultIsEmpty(false);
                      return;
                    }
                    searchMerchFunc();
                  }}
                />
                <div
                  className="custom-scrollbar"
                  style={{
                    marginTop: 16,
                    width: "100%",
                    maxHeight: 236,
                    overflowY: "scroll",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {searchResultIsEmpty && (
                    <PretendardText
                      style={{
                        fontSize: "14px",
                        fontWeight: "400",
                        lineHeight: "22px",
                        color: "#aaa",
                      }}
                    >
                      검색 결과가 없습니다.
                    </PretendardText>
                  )}
                  {searchMerchList.map((item, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 10,
                          padding: "15px 0px",
                          borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                        }}
                      >
                        <PretendardText
                          className="truncate"
                          style={{
                            width: 500,
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "22px",
                            color: "#aaa",
                          }}
                        >
                          {item.title || ""}
                        </PretendardText>
                        <GrayBtn
                          style={{
                            backgroundColor: "#313233",
                          }}
                          onClick={() => {
                            setProductManagementValue((prevProductData) => ({
                              ...prevProductData,
                              relatedMerchIdList: [
                                ...prevProductData.relatedMerchIdList,
                                item.id,
                              ],
                              relatedMerchList: [
                                ...prevProductData.relatedMerchList,
                                item,
                              ],
                            }));

                            setPopupOpen((prevPopup) => ({
                              ...prevPopup,
                              relationProduct: false,
                            }));
                          }}
                        >
                          선택
                        </GrayBtn>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </Popup>
        </PopupOverLay>
      )}

      {/* 임시저장 팝업 */}
      {popupOpen.temporary && (
        <PopupOverLay
          isOpen={true}
          onClick={() => {
            setPopupOpen((prevPopup) => ({
              ...prevPopup,
              temporary: false,
            }));
          }}
        >
          <Popup
            headerTitle="임시저장 글"
            noFooter={true}
            onClick={() => {
              setPopupOpen((prevPopup) => ({
                ...prevPopup,
                temporary: false,
              }));
            }}
          >
            <div
              className="custom-scrollbar"
              style={{
                width: "100%",
                maxHeight: 284,
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                marginTop: 16,
                padding: "0px 30px",
              }}
            >
              {storageList.map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      width: "100%",
                      height: 71,
                      padding: "15px 0px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderBottom:
                        "0.5px solid var(--outline1, rgba(255, 255, 255, 0.12))",
                    }}
                  >
                    <div
                      style={{
                        width: 515,
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleLoadStorageItem(item.id);
                      }}
                    >
                      <PretendardText
                        className="truncate"
                        style={{
                          width: "100%",
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "22px",
                          letterSpacing: "-0.3%",
                          color: "#aaa",
                        }}
                      >
                        {item.title}
                      </PretendardText>
                      <PretendardText
                        className="truncate"
                        style={{
                          width: "100%",
                          fontWeight: 500,
                          fontSize: 13,
                          lineHeight: "18.75px",
                          color: "rgba(181, 181, 181, 0.5)",
                        }}
                      >
                        {moment(item.updatedAt).format("YYYY-MM-DD HH:mm")}
                      </PretendardText>
                    </div>
                    <RedBtn
                      onClick={() => {
                        setDeleteStorageItemId(item.id);
                        setDeleteStorageItemModalOpen(true);
                      }}
                    >
                      삭제
                    </RedBtn>
                  </div>
                );
              })}
            </div>
          </Popup>
        </PopupOverLay>
      )}

      {/* 일반 알림 모달창 */}
      {modalOpen && (
        <Modal
          type="alert"
          title={modalMsg}
          text=""
          setModalOpen={setModalOpen}
          onClick={() => {
            setModalOpen(false);
          }}
        />
      )}

      {/* 임시저장 삭제하기 모달 */}
      {deleteStorageItemModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteStorageItemModalOpen}
          onClick={handleDeleteStorageItem}
        />
      )}

      {/* 업로드하기 모달창 */}
      {createModalOpen && (
        <Modal
          type=""
          title="상품을 등록하시겠습니까?"
          text=""
          setModalOpen={setCreateModalOpen}
          onClick={createProductFunc}
        />
      )}
    </>
  );
};

export default ShoppingProductCreateEtc;

const BasicContentSettingInputWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
`;

const BasicContentSettingInputTitle = styled(PretendardText).attrs(
  (props) => {}
)`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
`;
